export default function stepperNav(pageToNavigate, page, setPage) {
  if (page.page > 4) return;

  switch (pageToNavigate) {
    case 0: {
      setPage({
        ...page,
        page: 0,
        place: null,
        motif: null,
        praticien: null,
        date: "",
        dateTo: "",
        valid: false,
      });
      break;
    }
    case 1: {
      setPage({
        ...page,
        page: 1,
        motif: null,
        praticien: null,
        date: "",
        dateTo: "",
        valid: false,
      });
      break;
    }
    case 2: {
      setPage({
        ...page,
        page: 2,
        praticien: null,
        date: "",
        dateTo: "",
        valid: false,
      });
      break;
    }
    case 3: {
      setPage({
        ...page,
        page: 3,
        date: "",
        dateTo: "",
        valid: false,
      });
      break;
    }
    default:
      return;
  }
}
